import { CustomButton } from "components/Common"
import CustomSearchBar from "components/Common/CustomTable/SearchBar"
import { columnsConnectorInsuranceMapping, columnsConnectorInsuranceMappingCode, columnsConnectorInsuranceMappingName, columnsInstrumentMapping, columnsInstrumentMappingCode } from "constant"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect, useDispatch } from "react-redux"
import { getConnectorInstrumentMappingUploadSuccess, getConnectorInsuranceMappingUploadSuccess } from "store/actions"
import { read, utils } from "xlsx"
import ButtonExport from "./ButtonExport"

const InsuranceTableButtons = ({
  onRefresh,
  onSearch,
  loadingInstrumentMapping,
  data,
  t,
  searchText,
  onChangeSearchText,
  onClearSearchText,
  onSubmit,
  onSetRows,
  insuranceMappings,
  loading
}) => {
  const [dataSource, setDataSource] = useState([])
  const [dataExport, setDataExport] = useState([])
  const [fileName, setFileName] = useState(t("common:Upload"))
  const [isUpload, setIsUpload] = useState(false)

  useEffect(() => {
    setDataSource(data)
  }, [data])
  const dispatch = useDispatch();

  const getDataExport = () => {
    let dt = dataExport.map(row => {
      let res = {}
      columnsConnectorInsuranceMapping.forEach(element => {
        res[element] = row[columnsConnectorInsuranceMappingCode[element]]
        if (element == "hisTestCode")
          res['insuranceCode'] = row['hisTestCode']
        else if (element == "hisTestName")
          res['insuranceName'] = row['hisTestName']
      });
      return res
    })
    return dt
  }

  useEffect(() => {
    setDataExport(insuranceMappings || [])
  }, [insuranceMappings])

  const getColumnExport = () => {
    return columnsConnectorInsuranceMappingName
  }

  const getInstrumentHisString = (value) => {
    if (value) {
      return `${value}`
    }
    return null
  }

  const handleImport = e => {
    const files = e.target.files
    if (files.length) {
      let rowChoose = []
      const file = files[0]
      const reader = new FileReader()
      reader.onload = event => {
        const wb = read(event.target.result)
        const sheets = wb.SheetNames
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]])
          let tmp = dataSource
          let rowChecked = [];
          rows.forEach(item => {
            if (item.insuranceCode && item.insuranceCode != '') {
              const ind = tmp.findIndex(x => x.lisTestCode == item.lisTestCode)
              if (ind >= 0) {
                tmp[ind].hisTestCode = getInstrumentHisString(item['insuranceCode']);
                tmp[ind].hisTestName = getInstrumentHisString(item['insuranceName'] || item['insuranceCode']);
                tmp[ind].message = getInstrumentHisString(item['insuranceCode']);
                // tmp[ind].message = getInstrumentHisString(item['hisTestCode']);
                tmp[ind].selected = 1;
                rowChoose.push(tmp[ind])
                rowChecked.push(item)
              }
            }
          })
          dispatch(getConnectorInsuranceMappingUploadSuccess(tmp))
          onSetRows(rowChoose)
        }
      }
      reader.readAsArrayBuffer(file)
    }
  }

  return (
    <React.Fragment>
      <div className="input-table-header-tat-setting"
      >
        <CustomButton
          color="secondary"
          outline
          onClick={() => {
            onRefresh()
          }}
        >
          <i className={`fas fa-sync-alt ${loading == true ? " loading-spin" : ""}`}></i>
        </CustomButton>
        <input
          id="importExcel"
          name="reportTemplateName"
          type="file"
          className=" d-none"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={e => {
            setFileName(e.target.files[0]?.name || t("common:Upload"))
            handleImport(e)
          }}
        />
        <CustomButton
          isEdit
          color="primary"
          outline
          onClick={() => {
            $(`#importExcel`).click()
            setIsUpload(true)
          }}
        >
          {fileName}
        </CustomButton>
        <ButtonExport
          rows={dataSource}
          data={getDataExport()}
          columns={getColumnExport()}
        />
        <CustomButton
          color="primary"
          onClick={() => { onSubmit() }}
        >
          {t('button:Save')}
        </CustomButton>
        <CustomSearchBar
          onSearch={onChangeSearchText}
          searchText={searchText}
          placeholder={t("common:Search")}
          onClear={onClearSearchText}
          onSubmit={(e) => {
            e.preventDefault()
            onSearch()
          }}
        />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = ({ hisConnector }) => ({
  loadingInstrumentMapping: hisConnector.loadingInstrumentMapping,
  insuranceMappings: hisConnector.insuranceMappings || []
})

const mapDispatchToProps = dispatch => ({

})

InsuranceTableButtons.displayName = 'InsuranceTableButtons';
export default withTranslation(["testConfig", "common", "button"], { withRef: true })(connect(
  mapStateToProps,
  mapDispatchToProps, null, { forwardRef: true }
)(InsuranceTableButtons))
